import React from "react";
import { Textarea as ChakraTextarea, type TextareaProps as ChakraTextareaProps } from "@chakra-ui/react";

type BaseTextareaProps = {
  /**
   * Indicates if the input is invalid. If `true`, the input will be styled with an error state.
   * @default false
   */
  isInvalid?: boolean;

  /**
   * Indicates if the input is disabled. If `true`, the input will be styled with a disabled state.
   * @default false
   */
  isDisabled?: boolean;
};

export type TextareaProps = BaseTextareaProps & Omit<ChakraTextareaProps, "isInvalid" | "isDisabled" | "size">;

export function Textarea({ isInvalid, isDisabled, ...props }: TextareaProps) {
  return (
    <ChakraTextarea
      // Ask 1Password to not autofill this input and not show their icon inside
      data-1p-ignore
      isInvalid={isInvalid}
      isDisabled={isDisabled}
      size="md"
      {...props}
    />
  );
}
